import { prefixerT } from '.'

export const ROUTE_VALE_CAJA = prefixerT('vale-caja')
export const ROUTE_APROBAR_VALE_CAJA = prefixerT('aprobar-vale-caja')
export const ROUTE_REPOSICION_CAJA_CHICA = prefixerT('reposicion-caja-chica')
